import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `DayWorkingTimeDirective` represent a working time ranges in a day.
 * It must be contained in a Gantt component(`GanttComponent`).
 * ```tsx
 * <GanttComponent dataSource={data} allowSelection={true} allowSorting={true}>
 * <DayWorkingTimeCollection>
 * <DayWorkingTime from='8' to='12'></DayWorkingTimeCollection>
 * <DayWorkingTime from='13' to='17'></DayWorkingTimeCollection>
 * </DayWorkingTimeCollection>
 * </GanttComponent>
 * ```
 */
export class DayWorkingTimeDirective extends ComplexBase {
}
DayWorkingTimeDirective.moduleName = 'dayWorkingTime';
export class DayWorkingTimeCollectionDirective extends ComplexBase {
}
DayWorkingTimeCollectionDirective.propertyName = 'dayWorkingTime';
DayWorkingTimeCollectionDirective.moduleName = 'dayWorkingTimeCollection';
